import React, { useState, useEffect } from "react";
import {
  Offcanvas,
  Button,
  Modal,
} from "react-bootstrap";

import {
  DisplaySettingsOutlined,
  WallpaperOutlined,
} from "@mui/icons-material";

import toast from "react-hot-toast";
import useForm from "../../hooks/useForm";
import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import useCalculator from "../../hooks/useCalculator";
import CalculadoraReplicaPGI from "./editComponents/CalculadoraReplicaPGI";

const CalculatorPGI = () => {
  const { calculator, editCalculator } = useCalculator();
  const { values, setValues } = useForm({
    state: true,
    publish: false,
    visible: true,
  });
  const [showEditCalculadora, setShowEditCalculadora] = useState(true);
//   const [objectId, setObjectId] = useState(null);
  const [modalFor, setModalFor] = useState(null);
  const [objectId, setObjectId] = useState(null)
  const handleClose = () => setShowEditCalculadora(false);
  const handleShow = () => setShowEditCalculadora(true);

  // MODAL GALERIA
  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);

  const handleModalClick = (modalFor, objectId) => {
    setModalFor(modalFor)
    setObjectId(objectId)
    handleShowGaleria()
  }

  useEffect(() => {
    setValues(calculator);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calculator]);

  const handleStepInput = ({ target }) => {
    setValues({
      ...values,
      t21: values.t21.map((step, i) => {
        return { ...step, [target.name]: target.value };
      }),
    });
  };

  const handleStepInputT180 = ({ target }) => {
    setValues({
      ...values,
      t180: values.t180.map((step, i) => {
        return { ...step, [target.name]: target.value };
      }),
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      editCalculator(values);
    } catch (error) {
      toast.error("Error al actualizar la sección");
    }
  };

  return (
    <div id="wrapperEditCalculator" className="wrapperPgi">
      <button onClick={handleShow} className="basePgi__setttings-button">
        <DisplaySettingsOutlined />
      </button>
      <div className="card container containerPgi pt-3 pb-3">
        <CalculadoraReplicaPGI />
      </div>

      {/* OFFCANVAS SETTING HOME*/}
      <Offcanvas
        show={showEditCalculadora}
        onHide={handleClose}
        placement="start"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>EDITAR SECCIÓN CALCULADORA</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={handleSubmit}>
            <button
              type="submit"
              className="settings_button-pleno news_button float-end"
            >
              GUARDAR
            </button>
            <div className="pgi__sidebar-container-items form-group w-100">
              <Modal
                id="galleryModal"
                className="modalContenedor__galeria"
                show={showGaleria}
                // objectId={objectId}
                onHide={handleCloseGaleria}
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <GaleriaPgiModal
                    editProduct={values}
                    setEditProduct={setValues}
                    stepId={objectId}
                    modalFor={modalFor}
                    handleCloseGaleria={handleCloseGaleria}
                  />
                </Modal.Body>
              </Modal>
              <h3 className="basePgi__comments">Viguetas T21</h3>
              {values?.t21 &&
                values?.t21?.map((step, index) => {
                  return (
                    <>
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          id="title"
                          defaultValue={step?.title}
                          onChange={handleStepInput}
                          placeholder="..."
                          required
                          maxLength={200}
                          minLength={2}
                        />
                        <label htmlFor="link2">Titulo</label>
                      </div>

                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          name="subtitle"
                          id="subtitle"
                          defaultValue={step?.subtitle}
                          onChange={handleStepInput}
                          placeholder="..."
                          required
                          maxLength={200}
                          minLength={2}
                        />
                        <label htmlFor="link2">Subtitulo</label>
                      </div>
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          name="description"
                          id="description"
                          defaultValue={step?.description}
                          onChange={handleStepInput}
                          placeholder="..."
                          required
                          maxLength={200}
                          minLength={2}
                        />
                        <label htmlFor="link2">Descripción</label>
                      </div>

                      <div className="form-floating">
                        <Button
                          className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                          onClick={() => handleModalClick("t21", step._id)}
                        >
                          Imagen desktop
                          <WallpaperOutlined />
                        </Button>
                        <p className="basePgi__comments">
                          <span>
                            Imagen para Escritorio (.jpg, .png). Proporción
                            16:9. Ancho máximo 2048px
                          </span>
                        </p>
                        <Button
                          className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                          onClick={() => handleModalClick("t21_mobile", step._id)}
                        >
                          Imagen mobile
                          <WallpaperOutlined />
                        </Button>
                        <p className="basePgi__comments">
                          <span>
                            Imagen Mobile (.webP, .jpg, .png). Proporción 9:16.
                            Ancho máximo 1200px
                          </span>
                        </p>
                      </div>
                    </>
                  );
                })}
              <hr />
              <h3 className="basePgi__comments">Viguetas T180</h3>
              {values?.t180 &&
                values?.t180?.map((step, index) => {
                  return (
                    <>
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          id="title"
                          defaultValue={step?.title}
                          onChange={handleStepInputT180}
                          placeholder="..."
                          required
                          maxLength={200}
                          minLength={2}
                        />
                        <label htmlFor="link2">Titulo</label>
                      </div>
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          name="subtitle"
                          id="subtitle"
                          defaultValue={step?.subtitle}
                          onChange={handleStepInputT180}
                          placeholder="..."
                          required
                          maxLength={200}
                          minLength={2}
                        />
                        <label htmlFor="link2">Subtitulo</label>
                      </div>
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          name="description"
                          id="description"
                          defaultValue={step?.description}
                          onChange={handleStepInputT180}
                          placeholder="..."
                          required
                          maxLength={200}
                          minLength={2}
                        />
                        <label htmlFor="link2">Descripción</label>
                      </div>

                      <div className="form-floating">
                        <Button
                          className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                          onClick={() => handleModalClick("t180", step._id)}
                        >
                          Imagen desktop
                          <WallpaperOutlined />
                        </Button>
                        <p className="basePgi__comments">
                          <span>
                            Imagen para Escritorio (.jpg, .png). Proporción
                            16:9. Ancho máximo 2048px
                          </span>
                        </p>
                        <Button
                          className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                          onClick={() => handleModalClick("t180_mobile", step._id)}
                        >
                          Imagen mobile
                          <WallpaperOutlined />
                        </Button>
                        <p className="basePgi__comments">
                          <span>
                            Imagen Mobile (.webP, .jpg, .png). Proporción 9:16.
                            Ancho máximo 1200px
                          </span>
                        </p>
                      </div>
                    </>
                  );
                })}
            </div>
          </form>

          {/****************end lista productos *************************** */}
        </Offcanvas.Body>
      </Offcanvas>
      {/*offC slides */}
    </div>
  );
};

export default CalculatorPGI;
